import React from "react";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";

const QuantityAnimal = () => {
  const handleLogout = (event) => {
    event.preventDefault();
    sessionStorage.clear("token");
    window.location = "/login";
  };

  return (
    <div>
      <div className="navbar">
        <a href="/home">
          <img className="cpf-logo" src="/assets/cpf-logo.jpg" />
        </a>
        <button className="logout-btn" onClick={handleLogout}>
          Log out
        </button>
      </div>
      <div className="thailand-market-container">
        <div className="thailand-market-grid">
          <Link
            className="global-market-menuitem"
            to="/thailand-market/quantity-animal"
          >
            ปริมาณตัวสัตว์
          </Link>
          <Link
            className="global-market-menuitem"
            to="/thailand-market/demand-animal"
          >
            ความต้องการอาหารสัตว์
          </Link>
          <Link
            className="global-market-menuitem"
            to="/thailand-market/share-market"
          >
            ส่วนแบ่งการตลาดอาหารสัตว์
          </Link>
          <Link
            className="global-market-menuitem"
            to="/thailand-market/sale-animal"
          >
            ยอดขายอาหารสัตว์ CPF
          </Link>
        </div>
        <div className="quantity-animal-title">
          ความต้องการปริมาณสัตว์ประเทศไทย
        </div>
        <table className="quantity-animal-table">
          <tr>
            <th></th>
            <th>ประเภท</th>
            <th>หน่วย</th>
            <th>2021</th>
            <th>2022</th>
            <th>2023</th>
            <th style={{ display: "flex", flexDirection: "column" }}>
              <div>%เติบโต</div>
              <div>2022-2023</div>
            </th>
          </tr>
          <tr>
            <td>
              <img className="quantity-animal-img" src="/assets/chick.png" />
            </td>
            <td>ลูกไก่เนื้อ</td>
            <td>ล้านตัว/สป.</td>
            <td>31.46</td>
            <td style={{ backgroundColor: "#e6f1e0" }}>34.53</td>
            <td style={{ backgroundColor: "#e6f1e0" }}>36.00</td>
            <td>4%</td>
          </tr>
          <tr>
            <td>
              <img className="quantity-animal-img" src="/assets/poultry.png" />{" "}
            </td>
            <td>ไก่ไข่</td>
            <td>ล้านตัว</td>
            <td>50.02</td>
            <td style={{ backgroundColor: "#e6f1e0" }}>50.36</td>
            <td style={{ backgroundColor: "#e6f1e0" }}>50.36</td>
            <td>-%</td>
          </tr>
          <tr>
            <td>
              <img
                className="quantity-animal-img"
                src="/assets/small-pig.png"
              />{" "}
            </td>
            <td>สุกรพันธุ์</td>
            <td>ล้านแม่</td>
            <td>0.69</td>
            <td style={{ backgroundColor: "#e6f1e0" }}>0.85</td>
            <td style={{ backgroundColor: "#e6f1e0" }}>0.92</td>
            <td>8%</td>
          </tr>
          <tr>
            <td>
              <img className="quantity-animal-img" src="/assets/pig.png" />{" "}
            </td>
            <td>สุกรขุน</td>
            <td>ล้านตัว</td>
            <td>14.00</td>
            <td style={{ backgroundColor: "#e6f1e0" }}>14.20</td>
            <td style={{ backgroundColor: "#e6f1e0" }}>17.00</td>
            <td>20%</td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default QuantityAnimal;
